import React from 'react';
import ContactCardPanel from '../contact-card-panel';

import Linklist from '../../Linklist';

const Offering = (props) => (
  <div className="offering">
    <div className="offering__general-text">
      {props.GeneralText && (
        <div dangerouslySetInnerHTML={{ __html: props.GeneralText }} />
      )}
      {props.GeneralFiles && <Linklist Links={props.GeneralFiles} />}
    </div>
    <ul className="offering__list">
      {props.Offers &&
        props.Offers?.map((offer, index) => (
          <li key={`${index}--${offer.Title}`}>
            <ContactCardPanel
              subheading={true}
              hasH3={true}
              contactCardHeading={offer.Title}
              isLast={index === props.Offers.length - 1}
            >
              <div dangerouslySetInnerHTML={{ __html: offer.Text }} />
              {offer.Files && <Linklist Links={offer.Files} />}
            </ContactCardPanel>
          </li>
        ))}
    </ul>
  </div>
);

export default Offering;
